import { PageLayout, PageBody } from "@/components/site/PageLayout";
import { GALLERY_IMAGES } from "@/data/services";

export default function GalleryPage() {
  return (
    <PageLayout eyebrow="Our Work" title="Gallery">
      <PageBody>
        <div data-testid="gallery-grid" className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:balance]">
          {GALLERY_IMAGES.map((img, i) => (
            <figure key={img.src} className="mb-5 break-inside-avoid group relative overflow-hidden" data-testid={`gallery-photo-${i}`}>
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent px-4 py-3 opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="font-mono text-xs uppercase tracking-[0.15em] text-white">{img.alt}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </PageBody>
    </PageLayout>
  );
}
